import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { showModal } from 'actions';

import { currencyFormat } from 'utils/currencyFormat';
import { locale } from 'utils/locale';
import {
  getServiceInfoForLocale,
  hasFinancingInLocale,
} from 'utils/localeServices';

import { Icon } from 'sheets';
import localize from 'components/Localize/Localize';

import styles from './FinancingPriceLink.css';
import translations from './translations';

const cx = classNames.bind(styles);

class FinancingPriceLink extends React.Component {
  getLocaleServiceInfo() {
    return getServiceInfoForLocale(this.props.locale);
  }

  hasFinancing() {
    return !locale(this.props.locale).isDE() && hasFinancingInLocale(this.props.locale);
  }

  getMonthlyPayment() {
    const monthlyPayment = this.props.price / this.getLocaleServiceInfo().financingDuration;

    return currencyFormat(monthlyPayment, this.props.locale, false);
  }

  renderFinancingLabel() {
    if (this.hasFinancing() && this.getLocaleServiceInfo().showMonthlyFinancing) {
      return `${this.props.t.calculatedFinancingWith1} ${this.getMonthlyPayment()}${this.props.t.calculatedFinancingWith2}`;
    }

    return this.props.t.financingWith;
  }

  renderFinancerName() {
    if (!this.props.t.iconKey) {
      return null;
    }

    return (
      <Icon
        className={styles[`icon`]}
        name={this.props.t.iconKey}
      />
    );
  }

  renderMoreLink() {
    if (!this.props.t.moreLink && this.hasFinancing()) {
      return null;
    }

    return (
      <a
        className={styles[`link--secondary`]}
        href={this.props.t.moreLink}
        target="_blank"
      >
        {this.props.t.more}
      </a>
    );
  }

  render() {
    if (!this.hasFinancing()) {
      return false;
    }

    const linkClassName = cx(`link`, { 'link--with-secondary': this.props.t.moreLink });

    return (
      <div className={styles[`container`]}>
        <button
          className={linkClassName}
          onClick={this.props.showModal.bind(this, this.props.t.modalKey)}
        >
          {this.renderFinancingLabel()}
          {this.renderFinancerName()}
        </button>
        {this.renderMoreLink()}
      </div>
    );
  }
}

FinancingPriceLink.propTypes = {
  price: PropTypes.number,
  showModal: PropTypes.func.isRequired,
  t: PropTypes.shape({
    calculatedFinancingWith1: PropTypes.string,
    calculatedFinancingWith2: PropTypes.string,
    financingWith: PropTypes.string.isRequired,
    iconKey: PropTypes.string,
    modalKey: PropTypes.string.isRequired,
    more: PropTypes.string,
    moreLink: PropTypes.string,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  showModal: (key) => {
    dispatch(showModal(key));
  },
});

export default connect(null, mapDispatchToProps)(localize(FinancingPriceLink, translations, false));
